import * as React from 'react';
import type { SVGProps } from 'react';

const IconRedLine = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 400" fill="none" {...props}>
    <path d="M15.9495 1.22803L4.7998 7.60172V25.9998" stroke="#F32A52" strokeMiterlimit="10" />
    <path d="M4.79674 25L4.79688 400" stroke="#F32A52" />
  </svg>
);
export default IconRedLine;
